import React from "react";
import { injectIntl } from "react-intl";
import DataGrid, { DataGridItem } from "components/data-grid";
import withStyles from "components/with-styles";
import { DeploymentAutocompleteSelect } from "components/autocomplete";
import styles from "./styles/search-form.css.js";
import { SearchClearButton } from "components/buttons";
import PropTypes from "prop-types";

const SearchForm = ({ classes, intl, onChange, searchState, onClear }) => (
  <DataGrid>
    <DataGridItem threeQuarter>
      <DeploymentAutocompleteSelect
        id="searchAutocomplete"
        name="deploymentId"
        placeholder={intl.formatMessage({ id: "app.page.deployment.list.search" })}
        label={intl.formatMessage({ id: "app.page.deployment.list.search.label" })}
        onChange={onChange}
        value={searchState.deploymentId}
      />
    </DataGridItem>
    <DataGridItem small className={classes.button_container}>
      <SearchClearButton className={classes.button} onClick={onClear} />
    </DataGridItem>
  </DataGrid>
);

SearchForm.propTypes = {
  /**
   * Estado del formulario de búsqueda
   */
  searchState: PropTypes.object,
  /**
   * Callback que se dispara con el borrado del formulario
   */
  onClear: PropTypes.func,
  /**
   * Callback que se dispara con el cambio del input
   */
  onChange: PropTypes.func,
};

export default injectIntl(withStyles(styles)(SearchForm));
